function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.67 17.118v-3.26a.815.815 0 011.63 0v3.26a.815.815 0 01-1.63 0zm-4.076 0v-3.261a.815.815 0 111.625 0v3.26a.815.815 0 11-1.629 0zm-4.075-.001v-3.26a.815.815 0 011.63 0v3.26a.815.815 0 11-1.63 0z",
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.428 7.337l-2.34-6.234a.818.818 0 111.534-.571l2.445 6.52a.82.82 0 01.048.285h4.891a.815.815 0 010 1.63h-.888l-1.019 10.188a4.068 4.068 0 01-4.051 3.667H6.774a4.07 4.07 0 01-4.052-3.667L1.704 8.967H.816a.815.815 0 110-1.63h4.889a.824.824 0 01.049-.285L8.199.532a.817.817 0 111.532.571L7.392 7.337zM4.345 18.992l-1-10.025h16.137l-1 10.025a2.439 2.439 0 01-2.429 2.2H6.779a2.438 2.438 0 01-2.429-2.2",
  fillRule: "evenodd"
});

function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.819 22.822",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2);
}

export default SvgShoppingBag;